"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireWildcard(require("react"));

var _DayPickerInput = _interopRequireDefault(require("react-day-picker/DayPickerInput"));

var _moment = require("react-day-picker/moment");

require("./InputDatePicker.scss");

function YearMonthForm(_ref) {
  var date = _ref.date,
      localeUtils = _ref.localeUtils,
      onChange = _ref.onChange,
      maxDate = _ref.maxDate,
      toggleYears = _ref.toggleYears,
      open = _ref.open;
  var months = localeUtils.getMonths();
  var years = [];
  var year = maxDate ? maxDate.getFullYear() : new Date().getFullYear();

  for (var i = year; i >= 1920; i -= 1) {
    years.push(i);
  }

  var handleChange = function handleChange(year) {
    onChange(new Date(year, date.getMonth()));
  };

  return /*#__PURE__*/_react.default.createElement("form", {
    className: "DayPicker-Caption"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "active-month"
  }, months[date.getMonth()]), /*#__PURE__*/_react.default.createElement("div", {
    onClick: toggleYears,
    className: "active-year"
  }, date.getFullYear(), open && /*#__PURE__*/_react.default.createElement("div", {
    className: "day-picker-years"
  }, years.map(function (year) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: year,
      value: year,
      onClick: function onClick() {
        return handleChange(year);
      }
    }, year);
  }))));
}

var BHGInputDatePicker = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(BHGInputDatePicker, _Component);

  var _super = (0, _createSuper2.default)(BHGInputDatePicker);

  function BHGInputDatePicker() {
    var _this;

    (0, _classCallCheck2.default)(this, BHGInputDatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      open: false,
      year: _this.props.date
    };

    _this.handleYearChange = function (year) {
      _this.setState({
        year: year,
        open: false
      });
    };

    return _this;
  }

  (0, _createClass2.default)(BHGInputDatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          year = _this$state.year,
          open = _this$state.open;
      var _this$props = this.props,
          disabled = _this$props.disabled,
          maxDate = _this$props.maxDate,
          minDate = _this$props.minDate,
          date = _this$props.date,
          placeholder = _this$props.placeholder,
          onChange = _this$props.onChange,
          error = _this$props.error,
          classNames = _this$props.classNames,
          showOverlay = _this$props.showOverlay;
      var disabledDays = disabled ? {
        daysOfWeek: [0, 1, 2, 3, 4, 5, 6, 7]
      } : {
        before: minDate,
        after: maxDate
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "bhg-input-date-picker"
      }, /*#__PURE__*/_react.default.createElement(_DayPickerInput.default, {
        classNames: classNames,
        format: "DD/MM/YYYY",
        formatDate: _moment.formatDate,
        placeholder: (0, _moment.formatDate)(maxDate, "DD/MM/YYYY"),
        value: date,
        dayPickerProps: {
          disabledDays: disabledDays,
          selectedDays: date,
          month: year,
          captionElement: function captionElement(_ref2) {
            var date = _ref2.date,
                localeUtils = _ref2.localeUtils;
            return /*#__PURE__*/_react.default.createElement(YearMonthForm, {
              date: date,
              maxDate: maxDate,
              localeUtils: localeUtils,
              open: open,
              toggleYears: function toggleYears() {
                _this2.setState({
                  open: !open
                });
              },
              onChange: _this2.handleYearChange
            });
          }
        },
        inputProps: {
          readOnly: true,
          className: "form-control day-picker" + (error ? " error" : ""),
          placeholder: placeholder,
          disabled: disabled
        },
        onDayChange: onChange,
        showOverlay: showOverlay
      }));
    }
  }]);
  return BHGInputDatePicker;
}(_react.Component);

exports.default = BHGInputDatePicker;
BHGInputDatePicker.defaultProps = {
  disabled: false,
  maxDate: null,
  minDate: null,
  date: null,
  placeholder: "",
  onChange: function onChange(e) {
    return console.log("e", e);
  },
  error: false,
  classNames: {
    overlayWrapper: "DayPickerInput-OverlayWrapper",
    container: "",
    overlay: "DayPickerInput-Overlay"
  },
  showOverlay: false
};